import { Card } from '@/components/ui/card'
import { StatsCardBaseProps, StatsCardBase, MobileLayoutVariant } from './StatsCardBase'
import { InfoTooltip } from '@/components/ui/info-tooltip'

interface StatsCardMobileProps extends StatsCardBaseProps {
  height?: string
  layout?: MobileLayoutVariant
  contentHeight?: string
}

/**
 * Mobile version of StatsCard
 * Uses base logic but has mobile-specific UI
 * Supports different layouts based on design requirements
 */
export const StatsCardMobile = ({
  icon,
  iconAlt,
  label,
  helpText,
  value,
  loading = false,
  height = 'h-auto',
  className = ''
}: StatsCardMobileProps) => {
  const displayValue = StatsCardBase.getDisplayValue(value, loading)
  const iconNode = typeof icon === 'string'
    ? <img src={icon} alt={iconAlt} className="w-4 h-4 dark:[filter:brightness(0)_invert(1)]" />
    : <span className="inline-flex h-4 w-4 items-center justify-center text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)]">{icon}</span>

  return (
    <Card variant="default" padding="none" className={`bg-white dark:bg-[#1c1c1c] border border-solid border-white dark:border-[#1c1c1c] relative ${height} p-[16px] ${className}`}>
      {/* Mobile Layout - Exact Figma sizes: card 122x134px, padding 16px, content 90x102px */}
      {/* Container: flex-col, gap-[16px] between Header and Value, items-start */}
      <div className="flex flex-col items-start gap-[16px]">
        {/* Header: Icon and Label with gap-[6px] between them (icon at y=0, text at y=22, so gap=6px) */}
        <div className="flex flex-col items-start gap-[6px] w-full">
          {/* Icon: size-[16px] at position (0, 0) */}
          {iconNode}
          {/* Label: text-[12px] leading-[16px], font-medium, color rgba(45,41,35,0.72), at y=22 */}
          <div className="flex items-center gap-1.5">
            <span className="font-plus-jakarta font-medium text-[12px] leading-[16px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)] whitespace-pre-wrap">
              {label}
            </span>
            {helpText ? <InfoTooltip content={helpText} ariaLabel={`${label} info`} /> : null}
          </div>
        </div>
        {/* Value: text-[20px] leading-[32px] tracking-[-0.2px], color #2d2923, at y=70 (gap 16px from Header end at y=54) */}
        <span className="font-plus-jakarta font-medium text-[20px] leading-[32px] text-[#2d2923] dark:text-[#fdfdfd] tracking-[-0.2px]">
          {displayValue}
        </span>
      </div>
    </Card>
  )
}
